module.exports = __webpack_public_path__ + "static/img/cabinet12_8.9e9f819b.gif";